import types from '../types/invoiceCoordinatorActionTypes';

export const setInputValue = (name, value) => {
  return { type: types.SET_INPUT_VALUE, payload: { name, value } }
}

export const resetAdminInvoiceValue = () => {
  return { type: types.RESET_PEOPLE_INVOICE_VALUES }
}
